import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-module-tag',
  templateUrl: './module-tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NzTagModule,
    NzToolTipModule,
    NzIconModule,
  ],
})
export class ModuleTagComponent implements OnChanges {
  @Input() clickable = true;
  @Input() allowTooltip = true;
  @Input() id!: string | number;
  @Input() module!: string;

  url = '';
  config?: {
    color: string;
    textColor: string;
    tooltip: string;
    icon: string;
  };

  private readonly moduleConfigs: Record<string, any> = {
    cart: {
      color: 'var(--module-cart)',
      textColor: 'var(--module-cart-text)',
      tooltip: 'Cart',
      icon: 'shopping',
    },
    workflow: {
      color: 'var(--module-workflow)',
      textColor: 'var(--module-workflow-text)',
      tooltip: 'Workflow',
      icon: 'partition',
    },
    account: {
      color: 'var(--module-account)',
      textColor: 'var(--module-account-text)',
      tooltip: 'Account',
      icon: 'bank',
    },
    workshop: {
      color: 'var(--module-workshop)',
      textColor: 'var(--module-workshop-text)',
      tooltip: 'Workshop',
      icon: 'control',
    },
  };

  callToAction(): void {
    if (this.clickable && this.url) {
      window.open(this.url, '_blank');
    }
  }

  ngOnChanges(): void {
    this.config = this.moduleConfigs[this.module];
    this.url =
      this.clickable && this.config ? `/${this.module}/${this.id}` : '';
  }
}
